import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { GestationalAgeComponent } from "@/Patient/Components/MedicalNote/ObstetricalFile/Control/GestationalAgeComponent";

class BritishColumbiaObstetricalFileSection14 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const section14 = this.props.form.Section14;

        return (
            <div className="section">
                <div className="row">
                    <div className="col-md-12">
                        <div className="flex-display" style={{ justifyContent: "space-between" }}>
                            {this.renderTitle(14, "ObstetricalFile_EdinburghScaleLabel")}
                            {this.controlRenderer.renderCheckbox(
                                "DeclinedLabel",
                                section14.Declined,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Section14.Declined = value),
                                "vertically-centered"
                            )}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="inline-flex-center flex-col-gap-sm nowrap">
                            {this.renderInlineDatePicker(
                                "DateLabel",
                                section14.Date,
                                value => this.props.mutateModelStateWithFormUpdate(s => {
                                    s.Section14.Date = value;
                                    this.setGestationalAgeSection14(s);
                                }),
                                ""
                            )}
                            {this.renderField({
                                label: "GestationAgeAbbreviationLabel",
                                field: <GestationalAgeComponent
                                    id="Edinburg_Section14_GA"
                                    gestationalAge={section14.GestationalAge}
                                    readonly={this.props.readonly}
                                    onChange={value => this.props.mutateModelStateWithFormUpdate(s => s.Section14.GestationalAge = value)}
                                    controlRenderer={this.controlRenderer}
                                />,
                                labelClassName: "padding-xs-right",
                                isInlineFlex: true
                            })}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="flex-display flex-col-gap-sm nowrap" style={{ justifyContent: "space-between" }}>
                            <div className="edinburgh-perinatal-label-textbox flex-col-gap-sm">
                                {this.renderMultipleLabel("TotalScoreLabel")}
                                <span style={{ width: "52px" }}>
                                    {this.controlRenderer.renderTextbox({
                                        value: section14.EdinburghTotalScore?.toString(),
                                        onChange: value => this.props.mutateModelState(s => s.Section14.EdinburghTotalScore = value && parseInt(value)),
                                        isInteger: true,
                                        isNumeric: true,
                                        maxLength: 3
                                    })}
                                </span>
                            </div>
                            <div className="edinburgh-perinatal-label-textbox flex-col-gap-sm">
                                {this.renderMultipleLabel("ObstetricalFile_AnxietySubscoreLabel", null, this.getLabelSuffix(`(${this.getString("ObstetricalFile_QuestionAbbrev3To5Label")})`, "extra-info-label"))}
                                <span style={{ width: "52px" }}>
                                    {this.controlRenderer.renderTextbox({
                                        value: section14.AnxietySubScore?.toString(),
                                        onChange: value => this.props.mutateModelState(s => s.Section14.AnxietySubScore = value && parseInt(value)),
                                        isInteger: true,
                                        maxLength: 3
                                    })}
                                </span>
                            </div>
                            <div className="edinburgh-perinatal-label-textbox flex-col-gap-sm">
                                {this.renderMultipleLabel("ObstetricalFile_SelfHarmSubscoreLabel", null, this.getLabelSuffix(`(${this.getString("ObstetricalFile_QuestionAbbrev10Label")})`, "extra-info-label"))}
                                <span style={{ width: "52px" }}>
                                    {this.controlRenderer.renderTextbox({
                                        value: section14.SelfHarmSubScore?.toString(),
                                        onChange: value => this.props.mutateModelState(s => s.Section14.SelfHarmSubScore = value && parseInt(value)),
                                        isInteger: true,
                                        maxLength: 3
                                    })}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="flex-row flex-space-between flex-col-gap-sm ">
                            {this.renderInlineTextbox({
                                label: "followUpLabel",
                                value: section14.FollowUp,
                                onChange: value => this.props.mutateModelState(s => s.Section14.FollowUp = value),
                                className: "flex-grow-1",
                                labelClassName: "bold text-nowrap",
                                maxLength: this.page2FieldLimits.Section14_DepressionScale_FollowUp.MaxChars
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileSection14 };
